import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F7F6FD] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-4">
          <Loader2 className="w-8 h-8 text-[#6150AD] animate-spin mx-auto" />
        </div>
        <p className="text-gray-600">Validando sitio web...</p>
      </div>
    </div>
  );
};

export default LoadingState;